import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mail, Lock, User,Phone  } from 'lucide-react';

import axios from 'axios';
import { useNotification } from "../components/NotificationContext";
const RegisterPage = () => {
  const navigate = useNavigate();
  const showNotification = useNotification();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const registerUser = async ({ firstName, lastName, email, phone, password,confirmPassword }) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, {
        firstName,
        lastName,
        email,
        phone,
        password,
        confirmPassword,
        isAgreementChecked:true
      });
  
      return response.data; // Başarılı ise backend'den gelen cevabı döner
    } catch (error) {
      console.error('Kayıt hatası:', error);
      return { success: false, message: 'Kayıt sırasında bir hata oluştu.' };
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
  
    if (formData.password !== formData.confirmPassword) {
      setError('Şifreler eşleşmiyor');
      return;
    }
  
    const { firstName,lastName, email, phone, password,confirmPassword } = formData;
    const result = await registerUser({ firstName,lastName, email, phone, password,confirmPassword });

    if (result.status) {
      showNotification("Kayıt başarılı!", "success");
      navigate('/login');
    } else {
      showNotification("Kayıt başarısız! Lütfen bilgilerinizi kontrol edin.", "error");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-secondary-light py-12"
    >
      <div className="container-custom max-w-3xl">
        <div className="bg-white rounded-lg shadow-medium p-8">
          <h1 className="text-2xl font-bold text-gray-dark mb-6">Hesap Oluştur</h1>
          
          {error && (
            <div className="bg-red-50 text-red-600 p-3 rounded-md mb-4">
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
          <div className="mb-4 grid grid-cols-2 gap-4">
  <div>
    <label htmlFor="firstName" className="block text-gray-dark mb-1">
      Ad
    </label>
    <div className="relative">
      <input
        type="text"
        id="firstName"
        name="firstName"
        value={formData.firstName}
        onChange={handleChange}
        className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
        required
      />
      <User className="absolute left-3 top-2.5 text-gray" size={18} />
    </div>
  </div>

  <div>
    <label htmlFor="lastName" className="block text-gray-dark mb-1">
      Soyad
    </label>
    <div className="relative">
      <input
        type="text"
        id="lastName"
        name="lastName"
        value={formData.lastName}
        onChange={handleChange}
        className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
        required
      />
      <User className="absolute left-3 top-2.5 text-gray" size={18} />
    </div>
  </div>
</div>

            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-dark mb-1">
                E-posta
              </label>
              <div className="relative">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
                  required
                />
                <Mail className="absolute left-3 top-2.5 text-gray" size={18} />
              </div>
            </div>
            <div className="mb-4">
  <label htmlFor="phone" className="block text-gray-dark mb-1">
    Telefon Numarası
  </label>
  <div className="relative">
    <input
      type="tel"
      id="phone"
      name="phone"
      value={formData.phone}
      onChange={handleChange}
      className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
      required
    />
    <Phone className="absolute left-3 top-2.5 text-gray" size={18} />
  </div>
</div>
            <div className="mb-4">
              <label htmlFor="password" className="block text-gray-dark mb-1">
                Şifre
              </label>
              <div className="relative">
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
                  required
                />
                <Lock className="absolute left-3 top-2.5 text-gray" size={18} />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="confirmPassword" className="block text-gray-dark mb-1">
                Şifre Tekrar
              </label>
              <div className="relative">
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
                  required
                />
                <Lock className="absolute left-3 top-2.5 text-gray" size={18} />
              </div>
            </div>
            
            <button
              type="submit"
              className="w-full btn-primary mb-4"
            >
              Kayıt Ol
            </button>
            <p className="text-sm text-gray text-center mb-4">
  Kaydı tamamlayarak <Link to="/uyelik-sozlesmesi" className="text-primary underline hover:text-primary-dark">üyelik sözleşmesini</Link> kabul etmiş olursunuz.
</p>
          </form>
          
          <p className="text-center text-gray">
            Zaten hesabınız var mı?{' '}
            <Link to="/login" className="text-primary hover:text-primary-dark">
              Giriş Yapın
            </Link>
          </p>
          
        </div>
      </div>
    </motion.div>
  );
};

export default RegisterPage;